export default "__VITE_ASSET__94017283__"